import {Routes} from '@angular/router';
import {NoAuthGuard} from '@core/guard/no-auth.guard';
import {AuthGuard, GuestOrAuthGuard} from '@core/guard';
import {NoInternetPage} from './pages/no-internet/no-internet.page';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'home-tabs',
    loadChildren: () => import('./pages/home-tabs/home-tabs-routing.module').then(m => m.HomeTabsPageRoutingModule),
    canActivate: [GuestOrAuthGuard],
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/auth/phone-number-login/phone-number-login.page').then(m => m.PhoneNumberLoginPage),
    canActivate: [NoAuthGuard],
  },
  {
    path: 'login-otp-verification',
    loadComponent: () => import('./pages/auth/phone-number-otp-verification/phone-number-otp-verification.page').then(m => m.PhoneNumberOtpVerificationPage),
    canActivate: [NoAuthGuard],
  },
  {
    path: 'set-basic-profile',
    loadChildren: () => import('./pages/auth/set-basic-profile/set-basic-profile-routing.module').then(m => m.SetBasicProfilePageRoutingModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'booking-success/:bookingId',
    loadChildren: () => import('./pages/booking-success/booking-success-routing.module').then(m => m.BookingSuccessPageRoutingModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'basic-info',
    loadChildren: () => import('./pages/profile/basic-info/basic-info-routing.module').then(m => m.BasicInfoPageRoutingModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'manage-vehicle',
    loadComponent: () => import('./pages/profile/manage-vehicle/manage-vehicle.page').then(m => m.ManageVehiclePage),
    canActivate: [AuthGuard],
  },
  {
    path: 'manage-vehicle/:vehicleId',
    loadComponent: () =>
      import('./pages/profile/manage-vehicle/vehicle-edit/vehicle-edit.page').then(m => m.VehicleEditPage),
    canActivate: [AuthGuard],
    canDeactivate: [(component: {confirmLeave: () => Promise<boolean>}) => component.confirmLeave()],
  },
  {
    path: 'charger-detail/:chargerId',
    loadComponent: () => import('./pages/charger-detail/charger-detail.page').then(c => c.ChargerDetailPage),
    canActivate: [GuestOrAuthGuard],
  },
  {
    path: 'station-detail/:stationId',
    loadComponent: () => import('./pages/station-detail/station-detail.page').then(c => c.StationDetailPage),
    canActivate: [GuestOrAuthGuard],
    data: {preload: false},
  },
  {
    path: 'partner-station-detail/:id',
    loadComponent: () => import('./pages/partner-station-detail/partner-station-detail.page').then(c => c.PartnerStationDetailPage),
    canActivate: [GuestOrAuthGuard],
    data: {preload: false},
  },
  {
    path: 'vehicle-add-wizard',
    loadComponent: () => import('./pages/vehicle-add-wizard/vehicle-add-wizard.page').then(c => c.VehicleAddWizardPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'vehicle-add-wizard/select-brand',
    loadComponent: () => import('./pages/vehicle-add-wizard/model-picker/model-picker.page').then(c => c.ModelPickerPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'vehicle-add-wizard/select-model',
    loadComponent: () => import('./pages/vehicle-add-wizard/model-picker/model-picker.page').then(c => c.ModelPickerPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'invoice-list',
    loadComponent: () => import('./pages/invoice/invoice-list/invoice-list.page').then(c => c.InvoiceListPage),
    canActivate: [AuthGuard],
    data: {preload: false},
  },
  {
    path: 'session/:id',
    loadComponent: () => import('./pages/invoice/invoice-detail/invoice-detail.page').then(c => c.InvoiceDetailPage),
    canActivate: [AuthGuard],
    data: {preload: false},
  },
  {
    path: 'roaming-session/:sessionId',
    loadComponent: () =>
      import('./pages/invoice/roaming-session-detail/roaming-session-detail.page').then(
        (c) => c.RoamingSessionDetailPage,
      ),
    canActivate: [AuthGuard],
    data: {preload: false},
  },
  {
    path: 'booking-options',
    loadComponent: () => import('./pages/booking-options/booking-options.page').then(c => c.BookingOptionsPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'enter-charge-code/:stationId',
    loadComponent: () =>
      import('./pages/enter-charge-code/enter-charge-code.page').then(c => c.EnterChargeCodePage),
    canActivate: [AuthGuard],
  },
  {
    path: 'charge-now',
    loadComponent: () => import('./pages/charge-now/charge-now.page').then(c => c.ChargeNowPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'partner-roaming-charge',
    loadComponent: () =>
      import('./pages/partner-roaming-charge/partner-roaming-charge.page').then(c => c.PartnerRoamingChargePage),
    canActivate: [AuthGuard],
  },
  {
    path: 'partner-roaming-live/:sessionId',
    loadComponent: () =>
      import('./pages/partner-roaming-live/partner-roaming-live.page').then(c => c.PartnerRoamingLivePage),
    canActivate: [AuthGuard],
  },
  {
    path: 'partner-roaming-confirmed/:sessionId',
    loadComponent: () =>
      import('./pages/partner-roaming-confirmed/partner-roaming-confirmed.page').then(
        c => c.PartnerRoamingConfirmedPage,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'charge-now-confirmed/:bookingId',
    loadComponent: () => import('./pages/charge-now-confirmed/charge-now-confirmed.page').then(c => c.ChargeNowConfirmedPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'book-slot',
    loadComponent: () => import('./pages/book-slot/book-slot.page').then(c => c.BookSlotPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'booking-summary/:bookingId',
    loadComponent: () => import('./pages/booking-summary/booking-summary.page').then(c => c.BookingSummaryPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'wallet',
    loadChildren: () => import('./pages/profile/wallet/wallet-routing.module').then(m => m.WalletPageRoutingModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'notification',
    loadComponent: () => import('./pages/notification-list/notification-list.page').then(m => m.NotificationListPage),
    canActivate: [AuthGuard],
    data: {preload: false},
  },
  {
    path: 'no-internet',
    component: NoInternetPage,
  },
  {
    path: 'reschedule/:id',
    loadComponent: () => import('./pages/reschedule-slot/reschedule-slot.page').then(m => m.RescheduleSlotPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'charging-live-tracking/:invoiceId',
    loadComponent: () => import('./pages/charging-live-tracking/charging-live-tracking.page').then(m => m.ChargingLiveTrackingPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'terms-and-condition',
    loadChildren: () => import('./pages/profile/settings/terms-and-condition/terms-and-condition-routing.module').then(m => m.TermsAndConditionPageRoutingModule),
    data: {preload: false},
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./pages/profile/settings/privacy-policy/privacy-policy-routing.module').then(m => m.PrivacyPolicyPageRoutingModule),
    data: {preload: false},
  },
  {
    path: 'help-support',
    loadChildren: () => import('./pages/profile/settings/contact-us/contact-us-routing.module').then(m => m.ContactUsPageRoutingModule),
    canActivate: [AuthGuard],
    data: {preload: false},
  },
  {
    path: 'about-us',
    loadChildren: () => import('./pages/profile/settings/about-us/about-us-routing.module').then(m => m.AboutUsPageRoutingModule),
    data: {preload: false},
  },
  {
    path: 'login-restricted',
    loadComponent: () => import('./pages/feature/login-restricted/login-restricted.page').then(m => m.LoginRestrictedPage),
    data: {preload: false},
  },
  {
    path: 'favorite-station-list',
    loadComponent: () => import('./pages/feature/favorite-station-list/favorite-station-list.page').then(m=> m.FavoriteStationListPage),
    canActivate: [AuthGuard],
    data: {preload: false},
  }
];
